import Wrapper from '@app/Wrapper.js'

Munio.CompanyIndex = class CompanyIndex extends Wrapper {
  component() {
    return import('./App.vue')
  }
}
